import { config } from '../core/config';
import { createOAuthState, createPkcePair } from '../utils/pkce';

const SSO_PKCE_KEY = 'mobile_sso_pkce';
const SSO_STATE_KEY = 'mobile_sso_state';
const SSO_EMAIL_KEY = 'mobile_sso_email';
export const MOBILE_WEB_SSO_CLIENT_ID = 'mobile-web';

export function getSsoCallbackUrl(): string {
  return `${window.location.origin}/auth/callback`;
}

export function getAppSsoAuthorizeBaseUrl(): string {
  return `https://login.${config.apiHost}/account/app-sso`;
}

export async function beginMobileSso(email: string): Promise<string> {
  const { verifier, challenge } = await createPkcePair();
  const state = createOAuthState();
  sessionStorage.setItem(SSO_PKCE_KEY, verifier);
  sessionStorage.setItem(SSO_STATE_KEY, state);
  sessionStorage.setItem(SSO_EMAIL_KEY, email.trim());

  const params = new URLSearchParams({
    email: email.trim(),
    client_id: MOBILE_WEB_SSO_CLIENT_ID,
    redirect_uri: getSsoCallbackUrl(),
    state,
    code_challenge: challenge,
    code_challenge_method: 'S256',
  });

  return `${getAppSsoAuthorizeBaseUrl()}?${params.toString()}`;
}

export function consumeSsoPkce(): { verifier: string; state: string; email: string } | null {
  const verifier = sessionStorage.getItem(SSO_PKCE_KEY);
  const state = sessionStorage.getItem(SSO_STATE_KEY);
  const email = sessionStorage.getItem(SSO_EMAIL_KEY) || '';
  sessionStorage.removeItem(SSO_PKCE_KEY);
  sessionStorage.removeItem(SSO_STATE_KEY);
  sessionStorage.removeItem(SSO_EMAIL_KEY);
  if (!verifier || !state) {
    return null;
  }
  return { verifier, state, email };
}

export function peekSsoEmail(): string {
  return sessionStorage.getItem(SSO_EMAIL_KEY) || '';
}

export function clearSsoSession(): void {
  sessionStorage.removeItem(SSO_PKCE_KEY);
  sessionStorage.removeItem(SSO_STATE_KEY);
  sessionStorage.removeItem(SSO_EMAIL_KEY);
}
